import { render, staticRenderFns } from "./CContainer.vue?vue&type=template&id=c636178a&scoped=true&"
import script from "./CContainer.vue?vue&type=script&lang=js&"
export * from "./CContainer.vue?vue&type=script&lang=js&"
import style0 from "./CContainer.vue?vue&type=style&index=0&id=c636178a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c636178a",
  null
  
)

export default component.exports